export default "__VITE_ASSET__6f361c33__"